import React from 'react'

function RegionMenu({region}) {
    return (
           <option  value={region}> {region}</option>
    )
}

export default RegionMenu
